import React from "react";
import { useDimensions } from "../../Util";
import { useNavigate } from "react-router-dom";

const MotivationPill=()=>{

    const {w,h} = useDimensions();
    const navigate = useNavigate();

    const imagePill = {
        height: w > h ? 2.5 * h : 2 * h,
        width: w > h ? 5 * h : 4 * h,
        marginTop: "5px",
        marginRight:w>h?"0px":"7px"
    }

    const btnHome = {
        padding:"7px",
        border:"3px solid #EEEEEE",
        background:"#00ADB5",
        color:"#EEEEEE",
        marginTop:"15px",
        borderRadius:"7px"
    }

    const close=()=>{
        navigate("/")
    }

    return <div>
        <img src={`/images/pill.png`} style={imagePill} alt="Description" />
        <p>The cost of 'one last time' is rarely just that—it’s the cost of many last times yet to come.</p>
        <div style={{textAlign:"center"}}>
            <button style={btnHome} onClick={close}>Close</button>
        </div>
    </div>
}

export default MotivationPill;